import { UserModel as BaseUserModel } from 'projects/core/src/lib/models/user.model';
import { AcStatusUserType } from './acstatus/ac-status.type';

export class UserModel extends BaseUserModel {

  directlink: string;
  role: string = 'moderator';
  userStatus: AcStatusUserType = null;
  avatar: string | null;

  get initials(): string {
    return (this.firstname && this.lastname) ? this.firstname[0] + this.lastname[0] : '-';
  }

  public setUserStatus(userStatus: AcStatusUserType): void {
    this.userStatus = userStatus;
    if (this.userStatus.timezone) {
      this.timezone = this.userStatus.timezone;
    }
    if (this.userStatus.timezone) {
      this.tz_offset = this.userStatus.tz_offset;
    }
    if (this.userStatus.avatar === 'DELETED') {
      this.avatar = null;
    } else if (this.userStatus.avatar) {
      this.avatar = this.userStatus.avatar;
    }
  }

  public isOnline(): boolean {
    return this.userStatus?.is_online === true;
  }

  public isBusy(): boolean {
    return false;
  }

}
